import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'

const FormItem = styled(Box)(({ theme }) => ({
    textAlign: 'left',
    '& .MuiFormLabel-root': {
        marginTop: 10,
        whiteSpace: 'nowrap',
        display: 'block',
    },
}))

export default FormItem
